module.exports = __webpack_public_path__ + "media/images/logo-15f25085988dcb3c6a57a06298aa7c61.png";